import { ALL_LOCATIONS } from '@solinkcorp/vd-common';
import useFluxStore from 'src/hooks/useFluxStore';
import useTabName from 'src/hooks/useTabName';
import { LocationStore } from 'stores/LocationStore';
import { type VideoDiscoverySite } from 'utils/types';
import { TAB_VIDEO } from 'vd-constants';

export function useLocationSelectorState(locations?: readonly VideoDiscoverySite[]) {
  const allLocations = useFluxStore(LocationStore, (store) => store.getLocations());
  const masterLocationsList: readonly VideoDiscoverySite[] = locations || allLocations;
  const ready = useFluxStore(LocationStore, (store) => store.getIsLocationsReady());
  const fetching = useFluxStore(LocationStore, (store) => !store.getHasFetchedLocations());
  // This needs to be > 1 instead of > 0 because the masterLocationsList includes an "all locations".
  const hasAccessToLocations =
    masterLocationsList.length > 1 ||
    (masterLocationsList.length === 1 && masterLocationsList[0].id !== ALL_LOCATIONS);

  const tabName = useTabName();
  const isVideoTab = tabName === TAB_VIDEO;

  const locationsWithoutAll = masterLocationsList.filter(
    (location) => location.id !== ALL_LOCATIONS,
  );

  // Hide locations with no cameras on the video page.
  const locationsWithoutNoCamerasVideoPage = isVideoTab
    ? locationsWithoutAll.filter((location) => !!location.cameras?.length)
    : locationsWithoutAll;

  return {
    masterLocationsList,
    ready,
    fetching,
    hasAccessToLocations,
    locationsWithoutNoCamerasVideoPage,
  };
}
